export default "__VITE_ASSET__DLTk38SY__"